import { useIntl } from 'react-intl';

import { IconHome } from '@xing-com/icons';
import type { SeoBreadcrumbItem } from '@xing-com/seo-breadcrumb';

import { CAREER_HUB_BASE_PATH } from '../constants';

const APPLICATION_BASE_PATH = `${CAREER_HUB_BASE_PATH}/bewerbung`;

export const useBreadCrumbsConfig = (): Record<string, SeoBreadcrumbItem[]> => {
  const { formatMessage } = useIntl();

  const root: SeoBreadcrumbItem = {
    icon: IconHome,
    url: CAREER_HUB_BASE_PATH,
    title: formatMessage({ id: 'CAREER_HUB_HOME_TITLE' }),
  };
  const application: SeoBreadcrumbItem = {
    title: 'Bewerbung',
    url: `${CAREER_HUB_BASE_PATH}/bewerbung-uebersicht`,
  };

  return {
    'karriere-ratgeber': [root],
    'karriere-ratgeber/bewerbung-uebersicht': [root, application],
    'karriere-ratgeber/bewerbung/besondere-bewerbung': [
      root,
      application,
      {
        title: 'Besondere Bewerbung',
        url: `${APPLICATION_BASE_PATH}/besondere-bewerbung`,
      },
    ],
    'karriere-ratgeber/bewerbung/bewerbungsarten-formate': [
      root,
      application,
      {
        title: 'Bewerbungsarten & Formate',
        url: `${APPLICATION_BASE_PATH}/bewerbungsarten-formate`,
      },
    ],
    'karriere-ratgeber/bewerbung/anschreiben': [
      root,
      application,
      {
        title: 'Anschreiben',
        url: `${APPLICATION_BASE_PATH}/anschreiben`,
      },
    ],
    'karriere-ratgeber/bewerbung/vorstellungsgespräch': [
      root,
      application,
      {
        title: 'Vorstellungsgespräch',
        url: `${APPLICATION_BASE_PATH}/vorstellungsgespräch`,
      },
    ],
    'karriere-ratgeber/bewerbung/lebenslauf': [
      root,
      application,
      {
        title: 'Lebenslauf',
        url: `${APPLICATION_BASE_PATH}/lebenslauf`,
      },
    ],
    'karriere-ratgeber/bewerbung': [
      root,
      {
        title: 'Bewerbung',
        url: APPLICATION_BASE_PATH,
      },
    ],
    'karriere-ratgeber/gehalt': [
      root,
      {
        title: 'Gehalt',
        url: `${CAREER_HUB_BASE_PATH}/gehalt`,
      },
    ],
    'karriere-ratgeber/fuhrung-und-management': [
      root,
      {
        title: 'Führung und Management',
        url: `${CAREER_HUB_BASE_PATH}/fuhrung-und-management`,
      },
    ],
    'karriere-ratgeber/arbeitsrecht': [
      root,
      {
        title: 'Arbeitsrecht',
        url: `${CAREER_HUB_BASE_PATH}/arbeitsrecht`,
      },
    ],
    'karriere-ratgeber/frau-macht-karriere': [
      root,
      {
        title: 'Frau macht Karriere',
        url: `${CAREER_HUB_BASE_PATH}/frau-macht-karriere`,
      },
    ],
    'karriere-ratgeber/themen-a-bis-z': [
      root,
      {
        title: 'Glossar',
        url: `${CAREER_HUB_BASE_PATH}/themen-a-bis-z`,
      },
    ],
  };
};
